import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrdersActions } from '../../@store/orders/orders.actions';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from '../dialogs/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class PendingChangesGuard implements CanDeactivate<any> {
  private readonly dialog = inject(MatDialog);
  private readonly store = inject(Store);

  public canDeactivate(component: any): boolean | Observable<boolean> {
    if (!component.showConfirmModal || component.isLocked) {
      return true;
    }

    const dialogData: ConfirmationDialogData = {
      title: 'Before you leave',
      message:
        'Click Save Changes or Cancel. If you click Cancel it will not save any changes that were made to the quote.',
      confirmText: 'SAVE',
      cancelText: 'CANCEL',
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData,
      disableClose: true,
      width: '500px',
    });

    return dialogRef.afterClosed().pipe(
      map((result) => {
        if (result) {
          component.initiateRedirect = false;
          component.onSubmit();
        } else {
          if (component.isManageOrders) {
            this.store.dispatch(OrdersActions.setUnlock({ id: component.orderId }));
          }
          component.showConfirmModal = false;
        }

        return true;
      }),
    );
  }
}
